import { useQuery } from "@apollo/client";
import { Suspense } from "react";
import { useIntl } from "react-intl";

import Suspender from "lib/Suspender";
import { WorkspaceFinancialsDoc } from "operations";

import { LoadingSkeleton } from "@joor/design-system";
import { totalUnits } from "./ProductCount";
import { StyledContent, StyledLabel, StyledTitle } from "./styledComponents";

const useDepthCount = (workspaceId: string, isBrand: boolean) => {
  const { data, loading } = useQuery(WorkspaceFinancialsDoc, {
    variables: { workspaceId },
  });

  const mappedUnits = data?.retailWorkspace?.assortments?.flatMap((a) =>
    a.financialOverview.financialDetails
      ?.filter((c) =>
        isBrand ? c.isBrandCurrency === true : c.isBrandCurrency === false
      )
      .map((c) => ({ currency: c.currencyCode, unit: c.units.unitDepth }))
  );
  const depth = totalUnits(mappedUnits);

  return { loading, depth };
};

export const DepthCount = ({
  workspaceId,
  moreCurrencies,
  isBrand,
}: {
  workspaceId: string;
  moreCurrencies: boolean;
  isBrand: boolean;
}) => {
  const intl = useIntl();
  const { loading, depth } = useDepthCount(workspaceId, isBrand);

  const listDepthCount = depth?.map((count) => (
    <StyledTitle data-testid="depth-count-value">
      {intl.formatNumber(count) ?? 0}
    </StyledTitle>
  ));

  return (
    <StyledContent>
      <StyledLabel>Depth</StyledLabel>
      <Suspense fallback={<LoadingSkeleton />}>
        <Suspender suspend={loading}>
          {moreCurrencies ? (
            listDepthCount
          ) : (
            <StyledTitle data-testid="depth-count-value">
              {depth[0] ? intl.formatNumber(depth[0]) : 0}
            </StyledTitle>
          )}
        </Suspender>
      </Suspense>
    </StyledContent>
  );
};
